module.exports = __webpack_public_path__ + "static/img/lifestyle_05.4cc123e7.jpg";